import React, { useCallback } from 'react';
import { TMonthOption } from '../../../api/endpoints/SubsetOption';
import Checkbox from '../../Inputs/Checkbox/Checkbox';
import Index from '../../Ui/CheckboxWrap';
import { flatMap, range, uniq } from 'lodash';
import SelectAllControl from "../SelectAllControl";

const specToOptions = (spec: TMonthOption): Array<number> => {
  return uniq(
    flatMap(spec.value.fcmonth, item => {
      return range(
        parseInt(item.from, 10),
        parseInt(item.to, 10) + 1,
        1
      );
    })
  );
};

const MonthsSelector = (props: {
  values: Array<number>;
  spec: TMonthOption;
  onChange: (values: Array<number>) => void;
}) => {
  const { values, spec, onChange } = props;
  const options = specToOptions(spec);

  const onCheckboxChange = useCallback((value: number, checked: boolean) => {
    onChange(checked ? [...values, value] : values.filter(v => v !== value));
  }, [onChange, values]);

  return (
    <div>
      <SelectAllControl onChange={onChange} values={options} className="margin-bottom-xs" />

      <Index>
        {
          options.map(option =>
            <Checkbox
              key={option}
              label={option.toString()}
              value={option}
              checked={values.includes(option)}
              name="months"
              onChange={(checked) => onCheckboxChange(option, checked)}
            />)
        }
      </Index>
    </div>
  );
};

export default MonthsSelector;
